import {Injectable} from "@angular/core";
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable()
export class GareService {
  private resourceUrl = environment.apiUrl + 'event/competition';

  constructor(private http: HttpClient) {
  }

  getAllCompetitions(): Observable<any> {
    return this.http.get<any>(this.resourceUrl);
  }

  getCompetition(id: number): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/' + id + '/header');
  }

  getCompetitionDetail(id: number): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/' + id);
  }

  getCompetitionPartecipants(id: number): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/' + id + '/partecipants');
  }

  saveCompetitionPartecipants(id: number, request: any): Observable<any> {
    return this.http.post<any[]>(this.resourceUrl + '/' + id + '/partecipants', request);
  }

  save(id: any, request: any): Observable<any> {
    return this.http.post<any>(this.resourceUrl + '/' + id, request);
  }

  sendToConi(id: number): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/' + id + '/coni');
  }

  deleteGaraConi(id: number, idevent: number): Observable<any> {
    return this.http.delete<any>(this.resourceUrl + '/coni/' + idevent + '/' + id);
  }

  deleteGara(id: number): Observable<any> {
    return this.http.delete<any>(this.resourceUrl + '/'  + id);
  }

  deleteGaraPartecipantiConi(id: number, idevent: number): Observable<any> {
    return this.http.delete<any>(this.resourceUrl + '/coni/partecipants/' + idevent + '/' + id);
  }

  downloadCovid(idEvent: number, idCompetition: number): Observable<Blob> {
    return this.http.get(environment.apiUrl + 'event/' + idEvent + '/pdf/covid/' + idCompetition, {responseType: 'blob'});
  }

}



// WEBPACK FOOTER //
// ./src/app/servizi/gare/gare.service.ts